// 학습자 정보(CHATS.TRAITS)·수집 항목(CHATS.COLLECT_KEYS)을 저장 모양으로 정리한다.
//
// 편집 중 목록에는 방금 추가한 빈 행·아직 안 적은 지시문이 남아 있다. 화면은 그대로 두고
// **서버로 나가는 값만** 정리해야 하므로 Chat.save 가 보낼 때 이걸 거친다.
// ⚠️ chat.save 는 챗 전체(`...this`)를 보낸다 — 용도·유도 방식 같은 다른 칸을 저장할 때도 이 목록이 같이 나간다.
//    예전엔 정리가 [저장] 버튼에만 있어서, 다른 칸 저장이 빈 행·빈 지시문을 그대로 DB 에 실었다.

export const NICKNAME_KEY = "nickname";

// 항목이 가질 수 있는 값 — 기본값·학습자별 내용 칸의 후보. [대화 설정] 탭(학습자 정보)과 [블록] 탭(스텝의
// 학습자별 내용·레벨별 낱말)이 함께 쓴다. 사전 테스트에 연결된 항목은 테스트 구간 목록(values)이 우선이다 —
// 지시문을 비워 둔 레벨도 레벨이다. 그 밖에는 값별 지시문의 값들.
export const knownValues = (t) =>
	(Array.isArray(t?.values) && t.values.length ? t.values : Object.keys(t?.guide?.map || {})).filter((v) => String(v).trim());

export const normalizeCollectKeys = (list) =>
	(Array.isArray(list) ? list : [])
		.map((it) => ({ key: (it?.key || "").trim(), desc: (it?.desc || "").trim() }))
		.filter((it) => it.key);

export const normalizeTraits = (list) =>
	(Array.isArray(list) ? list : [])
		.map((it) => {
			const out = { key: (it?.key || "").trim(), desc: (it?.desc || "").trim() };
			// 값이 없을 때 쓰는 값({{변수}}·학습자별 내용 선택). 비면 저장하지 않는다.
			if (String(it?.default ?? "").trim()) out.default = String(it.default).trim();
			// ⭐ 닉네임은 기본 제공 입력 — 서버도 저장·게이트·지시문에 안 쓴다. 기본값·설명만 남긴다.
			if (out.key === NICKNAME_KEY) return out;
			if (it.write) out.write = true;
			// ⚠️ required:false 를 버리면 안 된다 — 예전엔 여기서 떨어져서, 사전 테스트가 '선택'으로 둔 항목이
			//    빌더에서 한 번 저장하는 순간 '필수'로 바뀌어 허브 게이트 조건이 조용히 늘었다.
			if (it.required === false) out.required = false;
			// 사전 테스트 연결 — 런타임은 안 읽는 저작 정보. 레벨 목록(values)은 지시문이 비어도 남겨야 한다.
			if (it.from?.chatId) {
				out.from = { chatId: it.from.chatId, title: it.from.title || "" };
				if (Array.isArray(it.values) && it.values.length) out.values = it.values;
			}
			// 빈 지시문은 저장하지 않는다 — 서버가 '지시 없음'으로 읽는 것과 같은 상태로 맞춘다.
			if (it.guide?.map) {
				const m = Object.fromEntries(
					Object.entries(it.guide.map).filter(([v, line]) => v.trim() && (line || "").trim()),
				);
				if (Object.keys(m).length) out.guide = { map: m };
			} else if ((it.guide?.template || "").trim()) {
				out.guide = { template: it.guide.template.trim() };
			}
			return out;
		})
		.filter((it) => it.key);
